export const SEVERITY = {
  CRITICAL: "CRITICAL",
  MAJOR: "MAJOR",
  MINOR: "MINOR",
  WARNING: "WARNING",
  INFO: "INFO",
  PLATFORM_AFFECTED: "PLATFORM_AFFECTED",
} as const;

export const SEVERITY_MAP_BE = Object.fromEntries(
  Object.entries(SEVERITY).map(([, value]) => {
    const backendValue = value === SEVERITY.INFO ? "OK" : value;
    return [value, backendValue];
  })
);

export const HEALTH_STATUS = {
  ...SEVERITY,
  HEALTHY: "HEALTHY",
} as const;

export const METRIC_ORDER = [
  SEVERITY.CRITICAL,
  SEVERITY.MAJOR,
  SEVERITY.MINOR,
  SEVERITY.WARNING,
  SEVERITY.INFO,
  SEVERITY.PLATFORM_AFFECTED,
] 

export const TIMEZONE_MAP: Record<string, string> = {
  EST: "America/New_York",
  CST: "America/Chicago",
  PST: "America/Los_Angeles",
  MST: "America/Denver",
  UTC: "UTC",
  GMT: "Europe/London",
};